<template><div style="display: none"></div></template>

<script>
//https://intranet.cdc.gov/cdcweb/web/metrics/adobe-analytics/docs/CDCMetricsApplications-LaunchGuidance-07102022-FINAL.docx

//https://intranet.cdc.gov/cdcweb/web/metrics/adobe-analytics/metrics-application-guidance.html

//http://intranet.cdc.gov/cdcweb/web/wcms/web-applications.html
//https://intranet.cdc.gov/cdcweb/media/2018/11/Template-Package-4-Resources-for-web-applications.pdf
//https://stackoverflow.com/questions/45047126/how-to-add-external-js-scripts-to-vuejs-components
// import templateMetrics from '@/scripts/metrics/templateMetrics';
export default {
    data() {
        return { is_script_loading: false, url: null };
    },
    created() {
        const vm = this;
        vm.executeMetrics();
    },
    methods: {
        executeMetrics,
        allLoadedLikeDocumentation,
        allLoaded,
        loadScript,
        load_script2,
        setMetricsValues,

        async use_script() {
            const vm = this;
            console.log('');

            try {
                await this.load_script();
                // .. do what you want after script has loaded
            } catch (err) {
                console.log(err);
            }
        }
    }
};

function setMetricsValues() {
    const vm = this;
    console.log('setMetricsValues');
    //replace enquire.register code which depends on the WCMS RD libraries and html markup with the following 4 lines of code to set s.prop49 based on the current viewport width
    //Logi open data applications are currently not using the WCMS RD libraries and don't have compatible html markup #32960.
    //http://stackoverflow.com/a/8876069
    if (!window.s) window.s = {};

    let s = window.s;

    s.pageName = document.title;
    s.channel = 'DPH BRFSS WEAT';
    s.ch = 'DPH BRFSS WEAT';
    window.shortTitle = 'DPH BRFSS WEAT';
    s.server = window.location.hostname;
    window.pageOptions = window.pageOptions || {};
    window.pageOptions.navigation = window.pageOptions.navigation || {};
    window.pageOptions.navigation.breadcrumbs = {
        mode: 'auto',
        showCurrentPage: true,
        prefix: [{}]
    };
    window.pageOptions.navigation.breadcrumbs =
        window.pageOptions.navigation.breadcrumbs || {};
    window.pageOptions.navigation.pathToSelect =
        window.pageOptions.navigation.pathToSelect || window.location.pathname;
}

function executeMetrics() {
    const vm = this;
    // templateMetrics.setupPublic();

    //vm.setMetricsValues();
    //-------------------------------------------------------------
    //   This
    //vm.load_script2('//TemplatePackage/4.0/assets/js/app.js');

    // const pLocal = [
    //     '/weat/static/scripts/jquery/jquery.min.js',
    //     '/weat/static/scripts/metrics/dev_launch-staging.js',
    //     '/weat/static/scripts/metrics/topic_levels.js'
    // ];

    // const pExternal = [
    //     '/weat/static/scripts/jquery/jquery.min.js',
    //     '/JScript/foresee/foresee-trigger.js',
    //     '/JScript/foresee-variables.js',
    //     '/TemplatePackage/4.0/assets/js/app.js',
    //     'https://wwwdev.cdc.gov/JScript/metrics/adobe/launch/b36c1852e229/2c674008a127/launch-e7960d1cb0e6-staging.min.js',
    //     'https://wwwdev.cdc.gov/JScript/metrics/topic_levels.js'
    // ];

    // const wfrs = [
    //     '/JScript/foresee-variables.js',
    //     '/JScript/foresee/foresee-trigger.js',
    //     '/TemplatePackage/contrib/libs/jquery/latest/jquery.min.js',
    //     '/TemplatePackage/4.0/assets/js/app.min.js?v=20-10-01T20:31:30Z',
    //     '/JScript/metrics/topic_levels.js',
    //     '/JScript/metrics/adobe/analytics_cdcgov.js'
    // ];

    vm.loadScript('/JScript/foresee/foresee-trigger.js');
    vm.loadScript('/JScript/foresee-variables.js');

    const p = [
        'https://code.jquery.com/jquery-3.6.1.min.js',
        //'/TemplatePackage/contrib/libs/jquery/latest/jquery.min.js',
        'https://nccd.cdc.gov/TemplatePackage/4.0/assets/js/app.js',
        '/JScript/metrics/topic_levels.js',
        '/JScript/metrics/adobe/analytics_cdcgov.js'
    ];

    let l = vm.loadScript(p[0]);
    for (let i = 1; i < p.length; ++i) {
        l = l.then(() => vm.loadScript(p[i]), error);
    }
    l.then(vm.allLoaded);

    // //'https://wwwdev.cdc.gov/JScript/metrics/topic_levels.js'

    // //'https://wwwdev.cdc.gov/JScript/metrics/adobe/launch/b36c1852e229/2c674008a127/launch-e7960d1cb0e6-staging.min.js'
    // .then(() => vm.loadScript(p[1]), error)
    // .then(() => vm.loadScript(p[2]), error)
    // //.then(() => vm.loadScript('/weat/static/scripts/templateApp.js'), error)
    // .then(vm.allLoadedLikeDocumentation);

    //   OR
    //window.CDC.tp4.public.appInit(window.pageOptions);
    //-------------------------------------------------------------

    // If another component is already loading the script
    vm.$root.$on('loading_script', (e) => {
        this.is_script_loading = true;
    });
}
function error(e) {
    console.log('error loading', e);
}

function allLoadedTest() {
    const vm = this;
    console.log('allLoadedLikeDocumentation');
    s.pageName = 'Behavioral Risk Factor Surveillance System | DPH | CDC';
    s.channel = 'DPH BRFSS WEAT';
    siteCatalyst.setAzEntry('BRFSS');
    siteCatalyst.setLevel1('Chronic');
    siteCatalyst.setLevel2('DPH');
    siteCatalyst.setLevel3('BRFSS');

    if (window.innerWidth < 768) s.prop49 = 1;
    else if (window.innerWidth < 992) s.prop49 = 2;
    else if (window.innerWidth < 1200) s.prop49 = 3;
    else s.prop49 = 4;

    //createNoScript();

    updateVariables(s);
}

function allLoaded() {
    //Code came from DOH_WFRS
    const vm = this;
    console.log('allLoaded');
    let s = window.s;
    s.pageName = 'Behavioral Risk Factor Surveillance System | DPH | CDC';
    s.channel = 'DPH BRFSS WEAT';
    siteCatalyst.setAzEntry('BRFSS');
    siteCatalyst.setLevel1('Chronic');
    siteCatalyst.setLevel2('DPH');
    siteCatalyst.setLevel3('BRFSS');

    if (window.innerWidth < 768) s.prop49 = 1;
    else if (window.innerWidth < 992) s.prop49 = 2;
    else if (window.innerWidth < 1200) s.prop49 = 3;
    else s.prop49 = 4;

    window.pageOptions = window.pageOptions || {};
    window.pageOptions.navigation = window.pageOptions.navigation || {};

    window.pageOptions.navigation.breadcrumbs = {
        mode: 'auto',
        showCurrentPage: true,
        prefix: [
            {
                text: 'WEAT',
                href: ''
            }
        ]
    };

    window.pageOptions.navigation.breadcrumbs =
        window.pageOptions.navigation.breadcrumbs || {};
    window.pageOptions.navigation.pathToSelect =
        window.pageOptions.navigation.pathToSelect || window.location.pathname;
    //window.CDC.tp4.public.appInit(window.pageOptions);

    var settings = window.pageOptions;

    settings = settings || {};
    settings.navigation = settings.navigation || {};
    settings.metrics = settings.metrics || {}; // The following interaction tracking mechanism does not appear to work as expected for built-in TP4 features.  Metrics
    // tracking was moved to tp-interactions.js.

    settings.interactionTrackList = settings.interactionTrackList || [];
    /* ITEMS TO BE INITIALIZED WHICH ARE SPECIFIC TO TP4
          (NOT USED IN OTHER CHANNELS LIKE SYNDICATION) */

    window.CDC.tp4.public.metricsInit(
        settings.metrics,
        settings.interactionTrackList
    );
    window.CDC.tp4.public.metricsTrackPage();
}

function allLoadedLikeDocumentation() {
    const vm = this;
    console.log('allLoadedLikeDocumentation');
    s.pageName = 'Behavioral Risk Factor Surveillance System | DPH | CDC';
    s.channel = 'DPH BRFSS WEAT';
    siteCatalyst.setAzEntry('BRFSS');
    siteCatalyst.setLevel1('Chronic');
    siteCatalyst.setLevel2('DPH');
    siteCatalyst.setLevel3('BRFSS');

    if (window.innerWidth < 768) s.prop49 = 1;
    else if (window.innerWidth < 992) s.prop49 = 2;
    else if (window.innerWidth < 1200) s.prop49 = 3;
    else s.prop49 = 4;

    //createNoScript();

    updateVariables(s);
}

function createNoScript() {
    let noscript = document.createElement('noscript');

    let a = document.createElement('a');
    a.setAttribute('href', 'https://www.adobe.com');

    let img = document.createElement('img');
    img.setAttribute(
        'src',
        'https://cdc.112.2o7.net/b/ss/cdcgov/1/H.21--NS/01/H.21--NS/0'
    );
    img.setAttribute('height', '1');
    img.setAttribute('width', '1');
    img.setAttribute('alt', 'Web Analytics');

    //     <a href="https://www.adobe.com">
    //         <img src="https://cdc.112.2o7.net/b/ss/cdcgov/1/H.21--NS/01/H.21--NS/0"
    //         height="1" width="1" alt="Web Analytics" />
    // </a>

    //noscript.setAttribute('src', url);

    a.appendChild(img);
    noscript.appendChild(a);

    // noscript.async = true;
    // noscript.onload = () => resolve();
    // noscript.onerror = (e) => reject(e, url);

    document.head.appendChild(noscript);
}

function loadScript(url) {
    const vm = this;
    return new Promise((resolve, reject) => {
        let script = document.createElement('script');
        script.setAttribute('src', url);
        script.async = true;
        script.onload = () => resolve();
        script.onerror = (e) => reject(e, url);
        document.head.appendChild(script);
    });
}

function loadScriptMultiComponent(url) {
    const vm = this;
    return new Promise((resolve, reject) => {
        // if script is already loading via another component
        if (vm.is_script_loading) {
            // Resolve when the other component has loaded the script
            this.$root.$on('script_loaded', resolve);
            return;
        }

        let script = document.createElement('script');
        script.setAttribute('src', url);
        script.async = true;

        this.$root.$emit('loading_script');

        script.onload = () => {
            // emit to global event bus to inform other components we are already loading the script
            this.$root.$emit('script_loaded');
            resolve();
        };

        document.head.appendChild(script);
    });
}

//https://wwwdev.cdc.gov/JScript/metrics/topic_levels.js
//https://wwwdev.cdc.gov/JScript/metrics/adobe/launch/b36c1852e229/2c674008a127/launch-e7960d1cb0e6-staging.min.js

// function load_script() {
//     let vm = this;
//     console.log('load_script');
//     return new Promise((resolve, reject) => {
//         console.log('load_script 2');
//         // if script is already loading via another component
//         if (vm.is_script_loading) {
//             // Resolve when the other component has loaded the script
//             this.$root.$on('script_loaded', resolve);
//             return;
//         }

//         let script = document.createElement('script');
//         script.setAttribute(
//             'src',
//             'https://wwwdev.cdc.gov/JScript/metrics/topic_levels.js'
//         );
//         script.async = true;

//         console.log('load_script 3', script);

//         this.$root.$emit('loading_script');

//         script.onload = () => {
//             /* emit to global event bus to inform other components
//              * we are already loading the script */
//             this.$root.$emit('script_loaded');
//             resolve();
//         };

//         document.head.appendChild(script);
//     });
// }

function load_script2(url) {
    const vm = this;

    let script = document.createElement('script');
    script.setAttribute('src', url);
    script.async = true;

    document.head.appendChild(script);
}

async function use_script() {
    try {
        await this.load_script();
        // .. do what you want after script has loaded
    } catch (err) {
        console.log(err);
    }
}

function pageLoad() {
    doAnalytics({
        levels: ['Chronic', 'DPH', 'DPH Apps'],
        AzEntry: '',
        channel: 'DPH BRFSS WEAT'
    });
}

function doAnalytics({ levels, AzEntry, channel }) {
    const _s = window.s,
        _siteCatalyst = window.siteCatalyst,
        _updateVariables = window.updateVariables;

    const pageHref = window.location.href.toLowerCase(),
        pageTitle = document.title,
        hostName = window.location.hostname.toLowerCase(),
        simpleUrl = pageHref.split('?')[0].split('#')[0];

    // s.pageName is not included in the documentation but is necessary for Analytics Reporting
    _s.pageName = pageTitle;
    // It was required for TP3 documentation, but got left out in future instruction

    _s.prop2 = pageHref;
    _s.prop26 = pageTitle;
    _s.prop30 = pageTitle;
    _s.prop31 = pageHref;
    _s.prop46 = pageHref;
    _s.server = hostName;
    //Simplified URL
    _s.prop73 = simpleUrl;
    _s.eVar73 = simpleUrl;

    _s.channel = channel;

    if (levels) {
        if (levels[0]) {
            //* Center Name *
            _siteCatalyst.setLevel1(levels[0]);
        }
        if (levels[1]) {
            //* Division, Office or Program Name *
            _siteCatalyst.setLevel2(levels[1]);
        }
        if (levels[2]) {
            //* CDC Topic Name *
            _siteCatalyst.setLevel3(levels[2]);
        }
    }

    if (AzEntry) {
        _siteCatalyst.setAzEntry(AzEntry);
    }

    // Update the level variables here.
    _updateVariables(_s);

    // Set the referrer value if passed on the querystring from a CDC page-level redirect.
    const qs = (function (a) {
        if (a === '') {
            return;
        }
        const b = {};
        for (let i = 0; i < a.length; ++i) {
            const p = a[i].split('=');
            if (p.length !== 2 || p[0] == '') {
                continue;
            }
            b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, ' '));
        }
        return b;
    })(window.location.search.substr(1).split('&'));

    const refParam = qs.CDC_AA_refVal;
    if (refParam) {
        _s.referrer = refParam;
    }

    const s_code = _s.t();
    if (s_code) document.write(s_code);
}

function doInteraction(
    interaction,
    applicationTitle = 'PLACES DTM Open Data',
    trackVars = 'prop41,prop40,prop49,prop46,prop2,prop31,channel'
) {
    const _s = window.s;
    _s.linkTrackVars = trackVars;
    _s.prop41 = applicationTitle; // This is used for creating analytics buckets in the report
    _s.prop40 = interaction;
    _s.tl(true, 'o', interaction);
}
</script>

<style scoped>
</style>
